import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/images/dacenterQrcode.jpeg';
const _hoisted_1 = {
  class: "qr-code"
};
const _hoisted_2 = {
  class: "icon-wrapper"
};
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, "移动端", -1);
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "qr-icon"
}, [/*#__PURE__*/_createElementVNode("svg", {
  t: "1665628918644",
  class: "icon",
  viewBox: "0 0 1025 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "2574",
  width: "24",
  height: "24"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M740.672 37.504c156.352 0 283.52 115.584 283.52 258.496 0 44.416-13.056 87.872-36.608 127.04-35.648 57.216-92.672 99.584-161.664 119.744a161.408 161.408 0 0 1-45.184 7.36 52.8 52.8 0 0 1-53.76-52.928c0-29.76 23.68-52.864 53.76-52.864 2.112 0 6.528 0 11.904-2.048 46.336-12.8 82.944-39.168 103.424-74.24 13.952-22.144 20.48-46.72 20.48-72.064 0-83.84-78.72-152.512-174.72-152.512a197.76 197.76 0 0 0-94.72 24.32c-50.816 28.544-80.896 76.16-80.896 128.192v443.904c0 89.984-50.752 172.672-134.848 219.328-45.184 25.408-96 38.272-147.712 38.272-156.288 0-283.52-115.648-283.52-258.56 0-44.352 13.12-87.872 36.608-127.04 35.648-57.216 92.736-99.584 161.664-119.68 19.328-5.312 32.384-7.36 45.184-7.36 30.272 0 53.824 23.36 53.824 52.864a52.8 52.8 0 0 1-53.76 52.928c-2.176 0-6.592 0-11.904 2.048-46.4 13.76-82.944 40.32-103.424 74.176-14.016 22.208-20.48 46.72-20.48 72.128 0 83.84 78.72 152.448 175.616 152.448a197.76 197.76 0 0 0 94.784-24.256c50.752-28.608 80.832-76.224 80.832-128.192V296.192c0-89.984 50.752-172.608 134.848-219.328a283.52 283.52 0 0 1 146.752-39.36z",
  fill: "#ffffff",
  "p-id": "2575"
})])], -1);
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "code-wrapper"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}), /*#__PURE__*/_createElementVNode("div", null, "微信扫码查看")], -1);
export function render(_ctx, _cache) {
  const _component_i_ep_Iphone = _resolveComponent("i-ep-Iphone");
  const _component_el_icon = _resolveComponent("el-icon");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_icon, {
    size: 18
  }, {
    default: _withCtx(() => [_createVNode(_component_i_ep_Iphone)]),
    _: 1
  }), _hoisted_3]), _hoisted_4, _hoisted_5]);
}